"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTransitionConsumer = exports.ModalTransition = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
const {
  Consumer,
  Provider
} = (0, _lodestarUtils.createContext)({
  isOpen: true,
  onExited: () => undefined
}, "ModalTransitionContext");

// checks if children exist and are truthy
const hasChildren = children => _react.default.Children.count(children) > 0 && _react.default.Children.map(children || [], child => !!child).filter(Boolean).length > 0;
const ModalTransition = _ref => {
  let {
    children
  } = _ref;
  const [previousChildrenForUnmount, setPreviousChildrenForUnmount] = (0, _react.useState)(undefined);

  /**
   * This effect's only job is to track children at each render.
   * When the component unmounts i.e. its children are unmounted, it will
   * set the most recently-tracked children as the current children.
   * This allows the Modal to retain its contents for the duration of the animation,
   * after which onExited will be called and we set that cache to null.
   */
  (0, _react.useEffect)(() => {
    const exiting = hasChildren(previousChildrenForUnmount) && !hasChildren(children);
    setPreviousChildrenForUnmount(exiting ? previousChildrenForUnmount : children);
  }, [previousChildrenForUnmount, children]);
  const onExited = () => {
    setPreviousChildrenForUnmount(null);
  };
  return /*#__PURE__*/_react.default.createElement(Provider, {
    value: {
      onExited: onExited,
      isOpen: hasChildren(children)
    }
  }, children || previousChildrenForUnmount);
};
exports.ModalTransition = ModalTransition;
const ModalTransitionConsumer = Consumer;
exports.ModalTransitionConsumer = ModalTransitionConsumer;
//# sourceMappingURL=ModalTransition.js.map